module.exports = __webpack_public_path__ + "static/media/elephant2.fa4597e4.jpg";